export default __webpack_public_path__ + "static/media/outline_location_on_white_48dp 1.fc3e2f13.svg";